/**
 * Verilen prefix ve parametrelerden bir cache anahtarı oluşturur
 * @param {string} prefix - Cache anahtarı için önek (ör: "contents", "social-posts")
 * @param {Object} params - Cache anahtarına dahil edilecek parametreler
 * @returns {string} Benzersiz cache anahtarı
 */
export const build = (prefix, params = {}) => {
  if (!prefix) {
    throw new Error('Cache anahtarı için prefix zorunludur')
  }
  
  // Null ve undefined değerleri temizle
  const cleanParams = Object.entries(params)
    .filter(([_, value]) => value !== null && value !== undefined)
    .reduce((acc, [key, value]) => {
      acc[key] = value
      return acc
    }, {})
  
  // Parametre yoksa sadece prefix döndür
  if (Object.keys(cleanParams).length === 0) {
    return prefix
  }
  
  // Parametreleri sırala (deterministik key oluşturmak için)
  const sortedParams = Object.entries(cleanParams)
    .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
  
  // Redis benzeri key formatı: prefix:key1=value1:key2=value2
  const paramString = sortedParams
    .map(([key, value]) => {
      // Dizileri ve nesneleri JSON string'e çevir
      const valueStr = typeof value === 'object' 
        ? JSON.stringify(value)
        : String(value)
      
      return `${key}=${encodeURIComponent(valueStr)}`
    })
    .join(':')
  
  return `${prefix}:${paramString}`
}